import { RadioGroup } from '@zoopla-eng/zds/radio-group';
import { queries } from '@zoopla-eng/zds/themes';
import { useBreakpointListener } from '@zoopla/dom-util';

export type AvailableFrom =
    | ''
    | 'now'
    | '1months'
    | '3months'
    | '6months'
    | '12months';

type AvailabilityProps = {
    value: AvailableFrom;
    onChange: (availableFrom: AvailableFrom) => void;
};

export const Availability = ({ value, onChange }: AvailabilityProps) => {
    const bisect = useBreakpointListener(queries.M[100], 'GT');

    return (
        <RadioGroup
            id="availability-time"
            bisect={bisect}
            label="Availability"
            value={value}
            items={[
                {
                    id: 'available_anytime',
                    value: '',
                    label: 'Available anytime'
                },
                {
                    id: 'available_immediately',
                    value: 'now',
                    label: 'Immediately'
                },
                {
                    id: 'available_1_months',
                    value: '1months',
                    label: 'Within 1 month'
                },
                {
                    id: 'available_3_months',
                    value: '3months',
                    label: 'Within 3 months'
                },
                {
                    id: 'available_6_months',
                    value: '6months',
                    label: 'Within 6 months'
                },
                {
                    id: 'available_12_months',
                    value: '12months',
                    label: 'Within 1 year'
                }
            ]}
            onValueChange={onChange}
        />
    );
};
